// Normaliza categorías para que "educativo" se trate como "Educación"
const CATEGORY_ALIASES: Record<string, string[]> = {
  "Educación": ["educativo", "educativa", "educativos", "educacion"],
  "Entrevistas": ["entrevista"],
  "Nacional": ["nacionales"],
  "Internacional": ["internacionales"],
  "Turismo": ["turístico", "turistico"],
  "Estadísticas": ["estadistica", "estadisticas"],
};

// Build reverse map: alias -> canonical
const ALIAS_TO_CANONICAL: Record<string, string> = {};
Object.entries(CATEGORY_ALIASES).forEach(([canonical, aliases]) => {
  aliases.forEach((alias) => {
    ALIAS_TO_CANONICAL[alias.toLowerCase()] = canonical;
  });
});

/**
 * Normaliza una categoría al nombre canónico.
 * Ej: "educativo" -> "Educación"
 */
export function normalizeCategory(category: string): string {
  const lower = category.toLowerCase();
  return ALIAS_TO_CANONICAL[lower] || category;
}

/**
 * Chequea si un item (category + tags) matchea una categoría objetivo,
 * considerando aliases.
 */
export function matchesCategory(
  itemCategory: string,
  itemTags: string[],
  targetCategory: string,
): boolean {
  const targetLower = targetCategory.toLowerCase();
  // Colección de sinónimos válidos para el target
  const synonyms = [targetLower];
  // Buscar si el target es canonical y agregar sus aliases
  Object.entries(CATEGORY_ALIASES).forEach(([canonical, aliases]) => {
    if (canonical.toLowerCase() === targetLower) {
      aliases.forEach((a) => synonyms.push(a.toLowerCase()));
    }
    // O si el target mismo es un alias, agregar el canonical
    if (aliases.some((a) => a.toLowerCase() === targetLower)) {
      synonyms.push(canonical.toLowerCase());
    }
  });

  const itemCatLower = (itemCategory || "").toLowerCase();
  if (synonyms.includes(itemCatLower)) return true;

  const tagsLower = itemTags.map((t) => t.toLowerCase());
  return tagsLower.some((t) => synonyms.includes(t));
}